import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { ICreatorsResponse } from 'app/interfaces/creator.interfaces';
import { IDiscoverItem } from '../../interfaces/discover.interfaces';

import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscoverService {
  public creators$: BehaviorSubject<IDiscoverItem[]> = new BehaviorSubject<IDiscoverItem[]>(null);
  private apiUrl = `${environment.apiBaseUrl}/d2c/creators`;

  constructor(private readonly http: HttpClient) {}

  getDiscoverData(filters?: {
    ready?: boolean;
    body_type?: string;
    hair?: string;
    tattoos?: boolean;
    piercings?: boolean;
    nationality?: string;
    rating?: 'nsfw' | 'sfw';
    new?: boolean;
  }): Observable<ICreatorsResponse> {
    const endpoint = this.apiUrl + '/discover';

    let params = new HttpParams();

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params = params.set(key, value.toString());
        }
      });
    }

    return this.http.get<ICreatorsResponse>(endpoint, { params });
  }

  getDiscoverCreatorData(creatorId: string): Observable<ICreatorsResponse> {
    const endpoint = this.apiUrl + '/' + creatorId;
    return this.http.get<ICreatorsResponse>(endpoint);
  }
}
